export function upperCaseFirstLetter(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lowerCaseAllWordsExceptFirstLetters(string) {
  return string.replace(/\w\S*/g, function(word) {
    return word.charAt(0) + word.slice(1).toLowerCase();
  });
}

export function isNumeric(value) {
  return /^-{0,1}\d+$/.test(value);
}

// OLD-VERSION OF  LICENSE PLATE FORMATTER

// export function formatLicensePlate(string) {
//   let final = '';
//   let parts = (string || '').split('');
//   for (let i = 0; i < parts.length; i++) {
//     if (i && isNumeric(parts[i]) != isNumeric(parts[i - 1])) final += '-';
//     final += parts[i];
//   }
//   return final;
// }

export function formatCurrencyValue(value) {
  if (parseFloat(value) % 1 !== 0) {
    // If the value has a fractional part, format with 2 decimal places

    return `${parseFloat(value).toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    })}`;
  } else {
    return `${parseFloat(value).toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
    })}`;
  }
}

export function formatCurrency(string) {
  const formatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  });

  let n = string ? formatter.format(Number(string)) : `€ ${parseFloat('0').toLocaleString('NL-nl')}`;
  return n;
}

export function fixPriceFormat(price, fractionDigits = 2) {
  return Number(price)?.toFixed(fractionDigits);
}

export function getQuantOfDecimalPlaces(stringOrNumber) {
  const separator = stringOrNumber?.toString()?.includes(',') ? ',' : '.';
  const quantity = stringOrNumber
    ?.toString()
    ?.split(separator)
    .map(e => e.length)?.[1];

  return quantity;
}

function GetSidecodeLicenseplate(Licenseplate) {
  if (!Licenseplate) return '';
  var arrSC = new Array();
  var scUitz = '';

  Licenseplate = Licenseplate?.replace(/-/g, '').toUpperCase();

  arrSC[0] = /^[a-zA-Z]{2}[\d]{2}[a-zA-Z]{2}$/; //      XX-NN-XX
  arrSC[1] = /^[\d]{2}[a-zA-Z]{2}[a-zA-Z]{2}$/; //      NN-XX-XX
  arrSC[2] = /^[a-zA-Z]{1}[\d]{3}[a-zA-Z]{2}$/; //      X-NNN-XX
  arrSC[3] = /^[a-zA-Z]{2}[\d]{3}[a-zA-Z]{1}$/; //      XX-NNN-X
  arrSC[4] = /^[\d]{1}[a-zA-Z]{2}[\d]{3}$/; //          N-XX-NNN
  arrSC[5] = /^[\d]{2}[a-zA-Z]{3}[\d]{1}$/; //          NN-XXX-N
  arrSC[6] = /^[a-zA-Z]{3}[\d]{2}[a-zA-Z]{1}$/; //      XXX-NN-X
  arrSC[7] = /^[\d]{1}[a-zA-Z]{3}[\d]{2}$/; //          N-XXX-NN
  arrSC[8] = /^[a-zA-Z]{1}[\d]{2}[a-zA-Z]{3}$/; //      X-NN-XXX

  //except licenseplates for diplomats
  scUitz = '^CD[ABFJNST][0-9]{1,3}$'; //for example: CDB1 of CDJ45

  for (let i = 0; i < arrSC.length; i++) {
    if (Licenseplate.match(arrSC[i])) {
      return i + 1;
    }
  }
  if (Licenseplate.match(scUitz)) {
    return 'CD';
  }
  return false;
}

export function formatLicensePlate(Licenseplate) {
  if (!Licenseplate) return;
  const Sidecode = GetSidecodeLicenseplate(Licenseplate);
  Licenseplate = Licenseplate?.replace(/-/g, '').toUpperCase();

  if (Sidecode <= 2) {
    // NN-XX-XX , XX-NN-XX
    return Licenseplate.substr(0, 2) + '-' + Licenseplate.substr(2, 2) + '-' + Licenseplate.substr(4, 2);
  }
  if (Sidecode == 3 || Sidecode == 8) {
    // X-NNN-XX, N-XXX-NN
    return Licenseplate.substr(0, 1) + '-' + Licenseplate.substr(1, 3) + '-' + Licenseplate.substr(4, 2);
  }

  if (Sidecode == 4 || Sidecode == 6) {
    // XX-NNN-X, NN-XXX-N
    return Licenseplate.substr(0, 2) + '-' + Licenseplate.substr(2, 3) + '-' + Licenseplate.substr(5, 1);
  }

  if (Sidecode == 5 || Sidecode == 9) {
    // N-XX-NNN, X-NN-XXX
    return Licenseplate.substr(0, 1) + '-' + Licenseplate.substr(1, 2) + '-' + Licenseplate.substr(3, 3);
  }

  if (Sidecode == 7) {
    // XXX-NN-X
    return Licenseplate.substr(0, 3) + '-' + Licenseplate.substr(3, 2) + '-' + Licenseplate.substr(5, 1);
  }

  return Licenseplate;
}

export function getAbbreviation(str) {
  return str
    .split(/\s+/)
    .map(word => word[0]?.toUpperCase())
    .join('');
}

export function getPrefixBeforeColon(str) {
  const index = str.indexOf(':');
  return index !== -1 ? str.slice(0, index).trim() : str?.substr(0, 10);
}
